export const checkForDuplicatedValues = <T>(values: T[]) => {
  return values.length !== new Set(values).size;
};
